import React from 'react'
import { useTranslation } from 'react-i18next';
import { Tooltip, Tag } from 'antd';

const CircuitButton = ({secondaryDisplays}) => {
  const { t } = useTranslation();
  const hasMultipleFaces = secondaryDisplays.filter(display => display.mirror_screens_count > 1).length

  const tooltipContent = `${t("The circuit has")} ${secondaryDisplays.length} ${t("screens")} 
  ${hasMultipleFaces ? `${t("and")} ${hasMultipleFaces} ${hasMultipleFaces > 1 ? t("have multiple faces") : t("has multiple faces")}` : ""}`

  return (
    <Tooltip 
      title={tooltipContent}
      placement="top"
    >
        <span>
          <Tag color="purple" size="small">
            <span style={{fontSize: "small"}}>
              {secondaryDisplays.length}{" "}
              {secondaryDisplays.length > 1 ? t("screens") : t("screen")}
            </span>
          </Tag>
        </span>
    </Tooltip>
  )
}

export default CircuitButton